import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/main.css";
import { store, persistor } from "./store/configureStore";
//import { routerMiddleware } from "react-router-redux"
import { PersistGate } from "redux-persist/lib/integration/react";

import Router from "./Router";

import { Provider } from "react-redux";

const App = () => {
  //@ts-ignore
  return (
    //@ts-ignore
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router />
      </PersistGate>
    </Provider>
  );
};

export default App;
